import React from "react";
import { Chart } from "react-google-charts";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/app/pages/industryAnalysis/SectionHeading";
import { options } from "@/app/pages/industryAnalysis/ConfigAndInterface";
import {setDigitalData} from "@/services/setDigitalData";
import { Link } from "react-router-dom";

const Segmentation = ({ title, chartDataValue }) => {
  const { t } = useTranslation();
  const sectionHeading = t("industryAnalysis.segmentation.sectionHeading");
  const descriptionPrefix = t(
    "industryAnalysis.segmentation.descriptionPrefix"
  );
  const descriptionSuffix = t(
    "industryAnalysis.segmentation.descriptionSuffix"
  );
  const ButtonStartYourFreeTrialLabel = t(
    "industryAnalysis.segmentation.ButtonStartYourFreeTrialLabel"
  );
  const description = title;
  let correctedChartData = JSON.parse(chartDataValue?.replaceAll("'", '"'));
  let addingChartColumn = correctedChartData.unshift([
    "Countries",
    "Industry Percentage",
  ]);
  const chartData = correctedChartData;

  return (
    <>
      <div className="industrySegmentationWrapper">
        <a className="anchor" name="geographic-segmentation-anchor"></a>
        <div className="content_card clearfix">
          <div className="text">
            <div className="container">
              <div className="row pad-lr-0">
                <div className="module_header pad-lr-0 clearfix">
                  <div className="col-md-12">
                    <SectionHeading heading={sectionHeading} />
                  </div>
                </div>

                <div className="col-md-5 ">
                  <div className="description marginLeftZeroPointOne">
                    {descriptionPrefix} {description} {descriptionSuffix}
                  </div>

                  <div className="module_cta marginLeftZeroPointOne">
                    <Link
                      className="button"
                      onClick={() => {setDigitalData({gcpPageName:'startYourFreeTrial'})}}
                      to={t("industryAnalysis.segmentation.ButtonStartYourFreeTrialLink")}                      
                    >
                      {ButtonStartYourFreeTrialLabel}
                    </Link>
                  </div>
                </div>

                <div className="col-md-7 graph">
                  <div className="chart_wrap">
                    <div className="industrySegmentationChartDiv">
                      <Chart
                        chartType="PieChart"
                        data={chartData}
                        options={options}
                        width={"100%"}
                        height={"400px"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Segmentation;
